import React from 'react';
import Dialog from '../Dialog';

interface RestoreJobsiteDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    restoreReason: string;
    setRestoreReason: (reason: string) => void;
}

const RestoreJobsiteDialog: React.FC<RestoreJobsiteDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    restoreReason,
    setRestoreReason
}) => {
    const handleClose = () => {
        onClose();
        setRestoreReason('');
    };

    return (
        <Dialog
            id="restore-jobsite-dialog"
            isOpen={isOpen}
            onClose={handleClose}
            width="w-[450px]"
            padding="px-10 py-10"
            className="z-[60]"
            hideCloseButton={true}
            disableBackdropClick={true}
        >
            <div className="text-center">
                <h3 className="text-xl font-bold mb-2">Restore Jobsite to Active Status?</h3>
                <p className="text-gray-600 mb-4">
                    Are you sure you want to restore this jobsite to active status? This will allow modifications to be made.
                </p>

                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                        Reason for restoration (optional)
                    </label>
                    <textarea
                        className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-black focus:border-black min-h-[100px]"
                        placeholder="Enter reason for restoration..."
                        value={restoreReason}
                        onChange={(e) => setRestoreReason(e.target.value)}
                        id="restore-reason-textarea"
                    />
                </div>

                <div className="flex justify-center gap-4">
                    <button
                        id="btn-restore-cancel"
                        onClick={handleClose}
                        className="btn-secondary px-8 py-2"
                    >
                        Cancel
                    </button>
                    <button
                        id="btn-restore-confirm"
                        onClick={onConfirm}
                        className="btn-primary text-white px-8 py-2"
                    >
                        Restore
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default RestoreJobsiteDialog;
